// extracted by mini-css-extract-plugin
export default {"fullWidth":"CreateAlertEventDialog_fullWidth__zr7Ii","bold":"CreateAlertEventDialog_bold__8ZiQK"};